import "./src/styles/global.css";
import React from "react";
import { ThemeProvider } from "./src/contexts/theme-context";
import smoothscroll from "smoothscroll-polyfill";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./src/reducers/index";

export const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>{element}</ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    smoothscroll.polyfill();
  }
};
